<template>
    <div class="picbook-box">
        <div class="title">
            宝贝作品
        </div>
        <div class="content">
            <!-- :pageData="pageData.readOpusUrl" -->
            <picbook
                :pageData="pageData.readOpusUrl"
                :route-name="'studyReport'"
            />
        </div>
    </div>
</template>

<script>
import picbook from '@/views/picbook/picbook.vue';

export default {
    components: {
        picbook
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {
                    readOpusUrl: {
                        headImage: '',
                        picbookData: []
                    },
                };
            }
        },
    },
    data() {
        return {

        };
    },
    watch: {
    },
    mounted() {
    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
.picbook-box {
    margin-top: .8rem;
    width: 9.15rem;
    height: 8.93rem;
    background: #FFFFFF;
    box-shadow: 0 .05rem .21rem 0 rgba(118,118,118,.15);
    border-radius: .43rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        margin-top: -.25rem;
        margin-bottom: .64rem;
        display: flex;
        padding-top: .33rem;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 4.53rem;
        height: 1.07rem;
        background: url('https://i.gsxcdn.com/2713148460_bp1opt2e.png') 0 no-repeat;
        background-size: cover;
        box-sizing: border-box;
    }

    .content {
        width: 8.51rem;
        height: 6.93rem;
        background: url('https://i.gsxcdn.com/2713969142_mc3xtwf9.png') 0 no-repeat;
        background-size: cover;
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: center;
    }
}
</style>
